import { useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';

import { isPlatformHost } from '@/config';
import { api, ApiError } from '@/lib/api';
import { useLocale } from '@/lib/i18n';

export default function ConfirmEmailPage() {
  const { token = '' } = useParams();
  const [searchParams] = useSearchParams();
  const { t } = useLocale();
  const [pending, setPending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const customer = searchParams.get('kind') === 'customer';
  const path = customer
    ? `/api/customers/email-verifications/${token}`
    : isPlatformHost()
      ? `/api/platform/auth/email-changes/${token}`
      : `/api/auth/email-changes/${token}`;

  async function confirm() {
    if (pending) return;
    setPending(true);
    setError(null);
    try {
      await api(path, { method: 'POST' });
      setDone(true);
    } catch (err: unknown) {
      setError(err instanceof ApiError ? err.message : t('prof.inviteExpired'));
    } finally {
      setPending(false);
    }
  }

  return (
    <main className="mx-auto flex min-h-screen max-w-md items-center px-4 py-10">
      <section className="w-full space-y-3 rounded-3xl border border-slate-200 bg-white p-6 text-slate-900">
        <h1 className="text-lg font-bold">{t('prof.confirmEmail')}</h1>
        {done ? (
          <Link to={customer ? '/account' : '/login'} className="inline-flex text-sm font-semibold text-amber-700">{customer ? t('prof.tabSettings') : t('prof.signIn')}</Link>
        ) : (
          <>
            {error && <p className="text-xs font-semibold text-rose-600">{error}</p>}
            <button type="button" disabled={pending} onClick={() => void confirm()} className="rounded-xl bg-slate-950 px-4 py-2 text-xs font-bold text-white disabled:opacity-50">
              {pending ? '…' : t('prof.confirmEmail')}
            </button>
          </>
        )}
      </section>
    </main>
  );
}
